/**
 * Related Containers block — slick carousel of sibling container posts.
 *
 * One slick instance per block. Shows 3 cards at desktop, 2 at tablet,
 * 1 on mobile. infinite:true so the carousel wraps and the arrows render
 * even when totalSlides equals slidesToShow (otherwise slick hides them
 * entirely on small related sets).
 */

jQuery(function ($) {
    const prevArrow = '<button type="button" class="slick-prev" aria-label="Previous related container">' +
        '<svg viewBox="0 0 24 49" fill="none" aria-hidden="true"><path d="M20 4 L4 24.5 L20 45" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    '</button>';

    const nextArrow = '<button type="button" class="slick-next" aria-label="Next related container">' +
        '<svg viewBox="0 0 24 49" fill="none" aria-hidden="true"><path d="M4 4 L20 24.5 L4 45" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    '</button>';

    $('.ck-related-containers__slider').each(function () {
        const $slider = $(this);

        if ( $slider.hasClass('slick-initialized') ) {
            return;
        }

        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            speed: 350,
            prevArrow,
            nextArrow,
            responsive: [
                { breakpoint: 1200, settings: { slidesToShow: 2 } },
                { breakpoint: 768,  settings: { slidesToShow: 1 } },
            ],
        });
    });
});
